export default __webpack_public_path__ + "static/santa-ema-merlot-3a64c3e1eabe78fec8fb438d7cd3cb90.jpg";